import { WifiOff } from 'lucide-react';

function OfflineNotice() {
  return (
    <div
      className="rounded-[18px] border border-[#efd8d0] bg-[#fbf3f0] px-4 py-3 text-[#8a5448] shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.025)]"
      role="alert"
    >
      <div className="flex items-start gap-3">
        <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#f3e2dc] text-[#96594d]">
          <WifiOff className="h-5 w-5" aria-hidden="true" />
        </div>
        <div>
          <strong className="block text-[0.96rem] font-semibold text-[#5c3128]">
            No internet connection
          </strong>
          <p className="m-0 mt-1 text-[0.9rem] leading-6 text-[#8a5448]">
            Some actions may not work until your connection comes back.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OfflineNotice;
